// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q9-2";
export var chatLink = "_q9-0";
export var chatText = "_q9-1";